export default "__VITE_ASSET__D2WxDC0Q__"